module.exports = __webpack_public_path__ + "img/collections.39ecf77.jpg";